<template>
  <footer id="footer" class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-column">
          <h4>联系我们</h4>
          <ul class="contact-info">
            <li>优易捷(北京)数据科技集团有限公司</li>
            <li >
              <i class="el-icon-location-information"></i
              >北京市房山区长阳镇碧桂园大厦1-3102
            </li>
            <li><i class="el-icon-message"></i> youyijie@126.com</li>
            <li><i class="el-icon-mobile-phone"></i> 15001372568</li>
            <li><i class="el-icon-phone"></i> 400 108 9858</li>
          </ul>
        </div>

        <div class="footer-column">
          <h4>关于我们</h4>
          <ul>
            <li><a href="#">公司简介</a></li>
            <li><a href="#">企业文化</a></li>
            <li><a href="#">荣誉资质</a></li>
          </ul>
        </div>

        <div class="footer-column">
          <h4>平台功能</h4>
          <ul>
            <li><a href="#">账号管理类</a></li>
            <li><a href="#">内容创作与发布类</a></li>
            <li><a href="#">物流运费类</a></li>
            <li><a href="#">营销推广类</a></li>
          </ul>
        </div>

        <div class="footer-column">
          <h4>客户案例</h4>
          <ul>
            <li><a href="#">民宿预订</a></li>
            <li><a href="#">乡村旅游</a></li>
            <li><a href="#">企业宣传</a></li>
            <li><a href="#">魅力乡村</a></li>
          </ul>
        </div>
      </div>

      <div class="footer-qrcodes">
        <div class="qrcode-item">
          <img src="../assets/qrcode_website.png" alt="扫码开通官网" />
          <p>扫码开通官网</p>
        </div>
        <div class="qrcode-item">
          <img src="../assets/qrcode_service.png" alt="一对一客服" />
          <p>一对一客服</p>
        </div>
      </div>

      <div class="footer-bottom">
        <p>北京优易捷科技有限责任公司 版权所有 © 2008-2025 Inc.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
/* 页脚样式 */
.footer {
  background-color: #1a1a1a; /* 深黑色背景 */
  color: #fff; /* 白色文字 */
  padding: 40px 0 20px; /* 调整内边距 */
  font-size: 14px;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 修改为grid布局 */
.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.footer-column {
  min-width: 200px;
}

.footer-column h4 {
  font-size: 16px;
  margin-bottom: 15px;
  color: #fff;
  position: relative;
  padding-bottom: 10px;
}

/* .footer-column h4::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: #409eff;
} */

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column li {
  margin-bottom: 10px;
  line-height: 1.6;
}

.footer-column a {
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  color: #fff;
}

.contact-info i {
  /* color: #409eff; */
  margin-right: 10px;
  width: 16px;
  text-align: center;
}

.footer-qrcodes {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 30px;
  margin-left: 330px;
}

.qrcode-item {
  text-align: center;
}

.qrcode-item img {
  width: 120px;
  height: 120px;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 8px;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #333;
  color: #aaa;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }

  .footer-content {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-qrcodes {
    margin-left: 0;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-qrcodes {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
</style>
